import { gql } from "@apollo/client";

export const getJourneys = gql`
    query getJourneys($queryParams: QueryParams!, $brandId: String) {
        getJourneys(queryParams: $queryParams, brandId: $brandId) {
            total
            hasMore
            items {
                id
                friendlyId
                name
                nodeId
                state
                flow
                updatedAt
                updatedBy
                createdAt
                createdBy
                finishedJourneys
                inProgressJourneys
                stateMachineArn
                triggerType
                version
                originalCreatedAt
                hidden
                tags {
                    id
                    name
                }
            }
        }
    }
`;

export const getJourneysAgents = gql`
    query getJourneysAgents {
        getJourneysAgents {
            updatedByNames
            createdByNames
        }
    }
`;

export const getJourney = gql`
    query ($id: String!) {
        getJourney(id: $id) {
            id
            friendlyId
            name
            description
            nodeId
            state
            flow
            finishedJourneys
            inProgressJourneys
            version
            createdAt
            originalCreatedAt
            updatedAt
            metadata
            stickyNotes {
                nodeId
                data
                position
            }
            tags {
                id
                name
            }
        }
    }
`;

export const getJourneyContacts = gql`
    query getJourneyContacts(
        $journeyId: String!
        $start: Float!
        $querySize: Float!
        $order: String!
        $orderBy: String!
    ) {
        getJourneyContacts(
            journeyId: $journeyId
            start: $start
            querySize: $querySize
            order: $order
            orderBy: $orderBy
        ) {
            total
            items {
                hashUuid
                userFirstName
                userLastName
                userContactPhone
                userEmail
                userExternalId
                userUuid
                currentNodeName
                journeyEnteredAt
                delayedUntil
                executionName
            }
            lastEvaluated
            hasMore
        }
    }
`;

export const getNodeContacts = gql`
    query getNodeContacts(
        $journeyId: String!
        $nodeId: String!
        $start: Float!
        $querySize: Float!
        $order: String!
        $orderBy: String!
    ) {
        getNodeContacts(
            journeyId: $journeyId
            nodeId: $nodeId
            start: $start
            querySize: $querySize
            order: $order
            orderBy: $orderBy
        ) {
            total
            items {
                hashUuid
                userFirstName
                userLastName
                userContactPhone
                userEmail
                userExternalId
                userUuid
                currentNodeName
                journeyEnteredAt
                delayedUntil
                executionName
            }
            lastEvaluated
            hasMore
        }
    }
`;

export const getScheduleBlockedDates = gql`
    query {
        getScheduleBlockedDates {
            startDate
            endDate
        }
    }
`;

export const getJourneysVersions = gql`
    query getJourneysVersions($id: String!) {
        getJourneysVersions(id: $id) {
            items {
                id
                version
                name
                createdAt
                createdBy
                isActive
                state
                versionName
                versionDescription
                triggerType
            }
        }
    }
`;

export const getJourneyByVersion = gql`
    query getJourneyByVersion($id: String!, $version: Int!) {
        getJourneyByVersion(id: $id, version: $version) {
            id
            friendlyId
            name
            description
            nodeId
            state
            flow
            finishedJourneys
            inProgressJourneys
            version
            createdAt
            originalCreatedAt
            updatedAt
            metadata
            stickyNotes {
                nodeId
                data
                position
            }
            tags {
                id
                name
            }
        }
    }
`;
